/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Change_AInputs */



/**
* | output |
* | --- |
* | "Yes, on the customer's page: the plan, storage and the Compliance Copilot. Upgrades and additions take effect at once and are billed from that day, so a bill..." |
*
* @param {Partner_Faq_Change_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_change_a = /** @type {((inputs?: Partner_Faq_Change_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Change_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, auf der Seite des Kunden: den Tarif, den Speicher und den Compliance Copilot. Upgrades und Ergänzungen gelten sofort und werden ab diesem Tag abgerechnet; eine Abrechnung kann daher die alte und die neue Konfiguration nebeneinander zeigen. Downgrades und Entfernungen gelten zum Ende des laufenden Zeitraums. Vertragskunden können während der Vertragslaufzeit nicht geändert werden.")
	return /** @type {LocalizedString} */ ("Yes, on the customer's page: the plan, storage and the Compliance Copilot. Upgrades and additions take effect at once and are billed from that day, so a bill can show the old and the new setup side by side. Downgrades and removals take effect at the end of the current period. Contract customers cannot be changed during their term.")
});